import ViewSDKClient from "../utils/ViewSDKClient";

export const loadPDF = ({ url, id }) => {
  const viewSDKClient = new ViewSDKClient();

  viewSDKClient.ready().then(() => {
    viewSDKClient.previewFile(
      id,
      {
        defaultViewMode: "FIT_WIDTH",
        showAnnotationTools: false,
        showLeftHandPanel: true,
        showPageControls: true,
        showDownloadPDF: false,
        showPrintPDF: false,
      },
      url
    );
  });
};
